// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const InsightsPageTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.insightsPageTitle"
        description="Insights page title."
        defaultMessage="Lens Insights"
    />
);
InsightsPageTitle.displayName = "InsightsPageTitle";

export const LensDetailsButtonText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.lensDetailsButtonText"
        description="Lens details button text."
        defaultMessage="View Lens Details"
    />
);
LensDetailsButtonText.displayName = "LensDetailsButtonText";

export const RealtimeMessage = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.realtimeMessage"
        description="Realtime message."
        defaultMessage="Measure performance with faster insights! We've reduced the data delay from 24+ hours to 1-2 hours."
    />
);
RealtimeMessage.displayName = "RealtimeMessage";

export const AllLensButtonText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.allLensButtonText"
        description="All lens button text."
        defaultMessage="All Lenses"
    />
);
AllLensButtonText.displayName = "AllLensButtonText";

export const LensPostsInfo = (props: { totalPosts: ReactNode; totalPosters: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.lensPostsInfo"
        description="Lens posts info."
        defaultMessage="Please note: metrics for { totalPosts } and { totalPosters } is only available from April 30, 2024."
        values={props}
    />
);
LensPostsInfo.displayName = "LensPostsInfo";

export const TabNameAudience = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.tabNameAudience"
        description="Tab name audience."
        defaultMessage="Audience"
    />
);
TabNameAudience.displayName = "TabNameAudience";

export const TabNameEngagement = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.tabNameEngagement"
        description="Tab name engagement."
        defaultMessage="Engagement"
    />
);
TabNameEngagement.displayName = "TabNameEngagement";

export const TabNameEventInsights = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.tabNameEventInsights"
        description="Tab name event insights."
        defaultMessage="Event Insights"
    />
);
TabNameEventInsights.displayName = "TabNameEventInsights";

export const TabNameConversion = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.tabNameConversion"
        description="Tab name conversion."
        defaultMessage="Conversion"
    />
);
TabNameConversion.displayName = "TabNameConversion";

export const TabNameFunnelAnalysis = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.tabNameFunnelAnalysis"
        description="Tab name funnel analysis."
        defaultMessage="Funnel Analysis"
    />
);
TabNameFunnelAnalysis.displayName = "TabNameFunnelAnalysis";

export const TabNameCreatorPayoutMonetization = (): ReactElement => (
    <FormattedMessage
        id="apps.lensInsights.components.tabNameCreatorPayoutMonetization"
        description="Tab name creator payout monetization."
        defaultMessage="Monetization"
    />
);
TabNameCreatorPayoutMonetization.displayName = "TabNameCreatorPayoutMonetization";
